import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import {
  CancelPresentation,
  Close,
  Dialpad,
  FiberDvr,
  FlashOn,
  FullscreenExit,
  KeyboardArrowDown,
  KeyboardArrowUp,
  MoreHoriz,
  OpenWith,
  VpnKey,
} from '@material-ui/icons';
import { ActionsMenu } from './ActionsMenu';
import { MobileNavButtons } from './MobileNavButtons';
import { useCitrusView } from '../../contexts/CitrusViewContext';
import { MobileNumPad } from './MobileNumPad';
import { MobilePlaybackButtons } from './MobilePlaybackButtons';
import { MobileAppKeyButtons } from './MobileAppKeyButtons';
import { Popper } from '../../components/Popper';
import { useUser } from '../../contexts/UserContext';
import { MobileConnectedControls } from './MobileConnectedControls';

interface Props {
  children: ReactNode;
  onCloseView(): void;
}

export const MobileView = ({ children, onCloseView }: Props) => {
  const { remote, sendCommand, connectedUser, disconnect } = useCitrusView();
  const { email } = useUser();
  const [moreRef, setMoreRef] = useState<HTMLDivElement | null>(null);
  const [appKeysOpen, setAppKeysOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [numPadOpen, setNumPadOpen] = useState(false);
  const [playbackOpen, setPlaybackOpen] = useState(false);
  const [moreOpen, setMoreOpen] = useState(false);
  const buttons = remote?.buttons ?? [];
  const disableButtons = connectedUser !== email;
  const classes = useStyles();

  const handlePress = (buttonName: string) => {
    const button = buttons.find(
      (button) => button.name.toUpperCase() === buttonName.toUpperCase()
    );
    if (button !== undefined) sendCommand(button.id);
  };

  const volumeFlyout = () => {};

  return (
    <>
      {menuOpen ? (
        <ActionsMenu open={menuOpen} onClose={() => setMenuOpen(false)} />
      ) : null}
      <Popper
        anchorEl={moreRef}
        isVisible={moreOpen}
        placement="right"
        style={{ background: 'transparent' }}
      >
        <div
          className={clsx(
            'transition-all duration-300 grid grid-cols-3 gap-2 grid-rows-1 p-2 bg-black rounded-full bg-red-200 w-screen h-screen',
            {
              'opacity-100': moreOpen,
              'opacity-0': moreOpen === false,
            }
          )}
        >
          <button
            disabled={disableButtons}
            className={clsx(
              classes.button,
              "relative children:mb-3 before:absolute before:bottom-1 before:content-['APP_KEYS'] before:text-white before:text-[0.45rem]"
            )}
            onClick={() => {
              setAppKeysOpen(!appKeysOpen);
              setMoreOpen(false);
            }}
          >
            <VpnKey />
          </button>
          <button
            disabled={disableButtons}
            className={clsx(
              classes.button,
              "relative children:mb-2 before:absolute before:bottom-0 before:content-['DISCONNECT'] before:text-white before:text-[0.30rem]"
            )}
            onClick={() => {
              disconnect();
              setMoreOpen(false);
            }}
          >
            <CancelPresentation />
          </button>
          <button disabled={disableButtons} onClick={() => setMoreOpen(false)}>
            <Close />
          </button>
        </div>
      </Popper>
      <MobileAppKeyButtons
        open={appKeysOpen}
        onClose={() => setAppKeysOpen(false)}
      />
      <MobilePlaybackButtons
        open={playbackOpen}
        onClose={() => setPlaybackOpen(false)}
      />
      <MobileNumPad open={numPadOpen} onClose={() => setNumPadOpen(false)} />
      <MobileNavButtons open={navOpen} onClose={() => setNavOpen(false)} />
      <div className="fixed top-0 grid grid-cols-10 w-screen h-screen bg-black z-[9990]">
        <div className="grid grid-rows-6 w-full gap-3 p-2 max-h-full">
          <button
            className={clsx(
              classes.button,
              "relative before:absolute before:z-10 before:content-['ACTIONS'] before:text-[0.45rem] before:text-white before:bottom-3 after:absolute after:z-0 after:h-3 after:w-[95%] after:bg-black after:rounded-full"
            )}
            onClick={() => setMenuOpen(true)}
          >
            <FlashOn fontSize="large" />
          </button>
          {/*<button*/}
          {/*  className={clsx(*/}
          {/*    classes.button,*/}
          {/*    "relative children:mb-3 before:absolute before:bottom-1 before:content-['MENUS'] before:text-white before:text-[0.45rem]"*/}
          {/*  )}*/}
          {/*  disabled={disableButtons}*/}
          {/*  onClick={() => setMenuButtonsOpen(!menuButtonsOpen)}*/}
          {/*>*/}
          {/*  <Menu />*/}
          {/*</button>*/}
          <button
            className={clsx(classes.button)}
            disabled={disableButtons}
            onClick={() => setNumPadOpen(!numPadOpen)}
          >
            <Dialpad />
          </button>
          <button
            className={clsx(classes.button)}
            disabled={disableButtons}
            onClick={() => setPlaybackOpen(!playbackOpen)}
          >
            <FiberDvr />
          </button>
          <div ref={setMoreRef} className="w-fit h-fit mt-auto">
            <button
              className={clsx(classes.button, '!border-none')}
              disabled={disableButtons}
              onClick={() => setMoreOpen(!moreOpen)}
            >
              <MoreHoriz />
            </button>
          </div>

          {/*<div className="flex flex-col gap-4 row-span-6 w-full h-full items-center">*/}
          {/*<button className={classes.button}>+</button>*/}
          {/*<button className={classes.button}>-</button>*/}
          {/*</div>*/}
        </div>
        <div
          className="relative flex my-auto h-[95%] children:h-[85%] children:items-center col-span-8"
          id="mobile-player-container"
        >
          <MobileConnectedControls />
          {children}
        </div>
        <div className="grid grid-rows-6 w-full p-2 justify-center">
          <button
            className={clsx(classes.button)}
            onClick={() => onCloseView()}
          >
            <FullscreenExit />
          </button>
          <div className="flex flex-col gap-3 row-span-5 w-full h-full items-center before:content-['CH/PG']">
            <button
              className={classes.button}
              disabled={disableButtons}
              onClick={() => handlePress('CH UP')}
            >
              <KeyboardArrowUp />
            </button>

            {/*<button*/}
            {/*  className={classes.button}*/}
            {/*  onClick={() => handlePress('OK')}*/}
            {/*>*/}
            {/*  OK*/}
            {/*</button>*/}
            <button
              className={classes.button}
              disabled={disableButtons}
              onClick={() => handlePress('CH DOWN')}
            >
              <KeyboardArrowDown />
            </button>
            <button
              className={classes.button}
              disabled={disableButtons}
              onClick={() => setNavOpen(!navOpen)}
            >
              <OpenWith />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const useStyles = () => ({
  button:
    'rounded-full border border-border-white aspect-square max-w-14 max-h-14 w-14 h-14 text-2xl flex items-center justify-center focus:bg-white/20 active:bg-white/20 disabled:opacity-30 disabled:focus:bg-transparent disabled:active:bg-transparent',
});
